// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__3GbQU","Label":"Checkbox_Label__Lew1c","InputElement":"Checkbox_InputElement__2L6da","Invalid":"Checkbox_Invalid__3ccR_"};